module.exports = __webpack_public_path__ + "officialStatic/img/trusteeship6.b0f1926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeship6.png
// module id = eerp
// module chunks = 0